import { Stack, Text } from '@chakra-ui/react';
import { JustToast } from '@getjust/leaf';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useCart } from '$hooks/queries';
import { useErrorAtom } from '$src/hooks/state/useErrorAtom';

export const ToastError = () => {
  const { t } = useTranslation();
  const { error, onErrorChange } = useErrorAtom();
  const { refetch: refetchCart } = useCart();

  const handleDismiss = useCallback(async () => {
    if (error?.reason === 'outOfStock' || error?.reason === 'shippingUnavailable') {
      await refetchCart();
    }

    onErrorChange(undefined);
  }, [error, onErrorChange, refetchCart]);

  return (
    <JustToast onBack={handleDismiss} back={t('buttons.back')} isOpen={Boolean(error)}>
      <Stack alignContent="left" justifyContent="left">
        <Text
          color="var(--text, #1C1C1C)"
          fontSize="2xl"
          textAlign="left"
          fontWeight="medium"
          lineHeight="normal"
          alignItems="flex-start"
          p="0"
        >
          {error?.title}
        </Text>
        <Text
          fontSize="md"
          fontWeight="350"
          color="var(--text, #1C1C1C)"
          textAlign="left"
          lineHeight="5"
          w="full"
          alignItems="flex-start"
          p="0"
        >
          {error?.sentence}
        </Text>
      </Stack>
    </JustToast>
  );
};
